<div class="main-wrapper" id="main-wrapper">
  <div class="header">
    <app-app-header></app-app-header>
  </div>

  <div class="sidebar" id="sidebar">
    <app-app-menu></app-app-menu>
  </div>
  <div class="page-wrapper">
    <div
      *ngIf="alertMessage"
      class="alert bg-{{ alertMessage.type }}-transparent alert-dismissible fade show mb-4 p-2"
    >
      {{ alertMessage.message }}
      <button type="button" class="btn-close fs-14" (click)="alertMessage = null">
        <i class="ti ti-x"></i>
      </button>
    </div>
    <router-outlet />
  </div>
</div>

<!-- <div class="alert-wrapper" *ngIf="alertMessage">
      <div class="alert-box alert-{{ alertMessage.type }} alert-dismissible fade show">
        {{ alertMessage.message }}

        <button type="button" class="btn-close" (click)="alertMessage = null"></button>
      </div>
    </div> -->
